export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}


export function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null; // Return null if the cookie does not exist
}


export function deleteCookie(name) {
    // Cookies here are set with path=/ (see setCookie), so the deletion must use
    // the same path to actually remove them. Expire it and zero its Max-Age.
    document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0;';
}
